import { useContext, useEffect, useState } from "react";
import "./checkout.styles.scss";
import { RestOrderContext } from "../../../../contexts/restaurantOrder.context";
import { OrderTypeContext } from "../../../../contexts/orderType.context";
const Checkout = () => {
  const [tableInput, setTableInput] = useState("");
  const [tableNumberClass, setTableNumberClass] = useState(
    "rest-tab-number-container"
  );

  const {
    restOrderContext,
    orderTotal,
    setTableNumber,
    sendToKitchenFunction,
    orderMessage,
    setOrderMessage,
  } = useContext(RestOrderContext);
  const { orderTypeContext } = useContext(OrderTypeContext);
  const handleClick = () => {
    if (orderTypeContext === "tableside" && tableInput === "") {
      console.log("Choose a tablenumber");
    } else {
      sendToKitchenFunction();
      setTableInput("");
    }
  };
  useEffect(() => {
    if (orderTypeContext === "tableside") {
      setTableNumberClass("rest-tab-number-container");
    } else if (orderTypeContext === "takeaway") {
      setTableNumberClass("rest-tab-number-container-invisible");
    }
  }, [orderTypeContext]);
  const handleChange = (event) => {
    const { value } = event.target;
    setTableInput(value);
    setTableNumber(value);
  };
  const handleMessageChange = (event) => {
    const { value } = event.target;
    setOrderMessage(value);
  };
  return (
    <div className="rest-tab-checkout">
      <div className={tableNumberClass}>
        <input
          type="text"
          placeholder="Table Number"
          value={tableInput}
          onChange={handleChange}
          className="rest-tab-number-input"
        />
      </div>
      <div className="rest-tab-checkout-box">
        <div className="checkout-box-header">
          <div className="checkout-box-item-details">
            <span className="checkout-box-item-name">Details</span>
          </div>
          <span className="checkout-box-item-price">Price</span>
        </div>

        {Object.keys(restOrderContext).map((index) => {
          const tempObject = restOrderContext[index];
          return (
            <div key={index} className="checkout-box-item">
              <div className="checkout-box-item-details">
                <span className="checkout-box-item-name">{index}</span>
                <span className="checkout-box-item-count">
                  x {tempObject["itemCount"]}
                </span>
              </div>
              <span className="checkout-box-item-price">
                {tempObject["itemTotal"]}
              </span>
            </div>
          );
        })}
        <div className="checkout-box-total">
          <span className="checkout-box-total-title">Total</span>
          <span className="checkout-box-total-value">{orderTotal}</span>
        </div>
      </div>
      <div className="rest-tab-message-container">
        <textarea
          className="rest-tab-message-textarea"
          placeholder="Enter Instructions (optional)"
          value={orderMessage}
          onChange={handleMessageChange}
        ></textarea>
      </div>
      <div className="rest-tab-sendkitchen-container">
        <button className="rest-tab-sendkitchen-button" onClick={handleClick}>
          Send to kitchen
        </button>
      </div>
    </div>
  );
};
export default Checkout;
